// Return error string or false if validation passes
const getFormFieldClass = ({ showValidation, error, value }) => {
  if (showValidation && value) {
    return error ? "not-valid" : "validated";
  }
  return "";
};

export default getFormFieldClass;
